// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../types";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SustainableEventBannerWrapperGetJourneysForSourceQueryVariables =
  Types.Exact<{
    input: Types.GetJourneysForSourceInput;
  }>;

export type SustainableEventBannerWrapperGetJourneysForSourceQuery = {
  __typename?: "Query";
  getJourneysForSource: Array<{
    __typename?: "GetJourneyForSourceResponse";
    journey: { __typename?: "Journey"; id: string };
  }>;
};

export type SustainableEventBannerWrapperEventFragment = {
  __typename?: "Event";
  UUID: string;
};

export const SustainableEventBannerWrapperEventFragmentDoc = gql`
  fragment SustainableEventBannerWrapperEvent on Event {
    UUID
  }
`;
export const SustainableEventBannerWrapperGetJourneysForSourceDocument = gql`
  query SustainableEventBannerWrapperGetJourneysForSource(
    $input: GetJourneysForSourceInput!
  ) {
    getJourneysForSource(input: $input) {
      journey {
        id
      }
    }
  }
`;

export function useSustainableEventBannerWrapperGetJourneysForSourceQuery(
  options: Omit<
    Urql.UseQueryArgs<SustainableEventBannerWrapperGetJourneysForSourceQueryVariables>,
    "query"
  >
) {
  return Urql.useQuery<SustainableEventBannerWrapperGetJourneysForSourceQuery>({
    query: SustainableEventBannerWrapperGetJourneysForSourceDocument,
    ...options,
  });
}
